/**
 * Compose a client's display name from optional first/middle/surname fields.
 *
 * Real-user feedback (2026-02): only `first_name` is required — surname is
 * optional. Rendering `${first} ${surname}` naively produces "BBC Podcast "
 * with a trailing space (and worse when middle_name is empty too:
 * "BBC  Podcast" with double spaces). This helper trims cleanly and falls
 * back to email → "Unknown client".
 */
export function clientDisplayName(client = {}) {
    const parts = [client.first_name, client.middle_name, client.surname]
        .map((p) => (typeof p === "string" ? p.trim() : ""))
        .filter(Boolean);
    if (parts.length) return parts.join(" ");
    if (client.email) return client.email;
    return "Unknown client";
}
